import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/Globals';
import { HttpService } from 'src/app/services/http-service';

@Component({
  selector: 'app-reg-driver-profile',
  templateUrl: './reg-driver-profile.component.html',
  styleUrls: ['./reg-driver-profile.component.scss']
})
export class RegDriverProfileComponent implements OnInit {
  globals = Globals;
  pForm: FormGroup;
  model: any = {};
  isLoadingResults = false;
  httpSub$: Subscription = null;
  fileToUpload: File = null;
  userAddress = '';
  city = '';
  country = '';
  state = '';
  zipCode = '';
  mailingAddress = '';
  mailingCity = '';
  mailingCountry = '';
  mailingState = '';
  mailingZipCode = '';
  isRental = false;
  private displayNameTouched = false;

  constructor(
    private service: HttpService,
    private fb: FormBuilder,
    private router: Router
  ) {}

  ngOnInit() {
    this.pForm = this.fb.group({
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      displayName: [null],
      email: [null, [Validators.required, Validators.email]],
      phoneno: [null, Validators.required],
      rental: ['0', Validators.required],
      monthlyRentalAmount: [null],
      dob: [null, Validators.required]
    });

    this.pForm.get('displayName').valueChanges.subscribe(() => {
      this.displayNameTouched = true;
    });
    this.pForm.get('firstName').valueChanges.subscribe((firstName: string) => {
      if (!this.displayNameTouched) {
        this.pForm.patchValue({ displayName: firstName || '' }, { emitEvent: false });
      }
    });

    const entered = JSON.parse(localStorage.getItem('driverProfile') || 'null');
    if (entered) {
      this.model.imageString = entered.profileImage;
      this.country = entered.country || '';
      this.city = entered.city || '';
      this.state = entered.state || '';
      this.zipCode = entered.postalCode || '';
      this.userAddress = entered.lineAddress || '';
      this.mailingAddress = entered.mailingLineAddress || '';
      this.mailingCity = entered.mailingCity || '';
      this.mailingCountry = entered.mailingCountry || '';
      this.mailingState = entered.mailingState || '';
      this.mailingZipCode = entered.mailingPostalCode || '';
      this.isRental = !!entered.rental;
      this.displayNameTouched = !!(entered.displayName && entered.displayName !== entered.firstName);
      this.pForm.patchValue({
        firstName: entered.firstName,
        lastName: entered.lastName,
        displayName: entered.displayName || entered.firstName || '',
        email: entered.email,
        phoneno: entered.phoneNumber,
        rental: entered.rental ? '1' : '0',
        monthlyRentalAmount: entered.monthlyRentalAmount,
        dob: entered.dob ? new Date(entered.dob * 1000) : null
      });
    }
  }

  radioChange(value: string) {
    this.isRental = value === '1';
    if (!this.isRental) {
      this.pForm.patchValue({ monthlyRentalAmount: 0 });
    }
  }

  handleAddressChange(address: any) {
    this.userAddress = address.formatted_address;
    (address.address_components || []).forEach((element: any) => {
      (element.types || []).forEach((type: string) => {
        if (type === 'locality') {
          this.city = element.long_name;
        } else if (type === 'postal_code') {
          this.zipCode = element.long_name;
        } else if (type === 'country') {
          this.country = element.long_name;
        } else if (type === 'administrative_area_level_1') {
          this.state = element.long_name;
        }
      });
    });
  }

  handleMailingAddressChange(address: any) {
    this.mailingAddress = address.formatted_address;
    this.mailingCity = '';
    this.mailingZipCode = '';
    this.mailingCountry = '';
    this.mailingState = '';
    (address.address_components || []).forEach((element: any) => {
      (element.types || []).forEach((type: string) => {
        if (type === 'locality') {
          this.mailingCity = element.long_name;
        } else if (type === 'postal_code') {
          this.mailingZipCode = element.long_name;
        } else if (type === 'country') {
          this.mailingCountry = element.long_name;
        } else if (type === 'administrative_area_level_1') {
          this.mailingState = element.long_name;
        }
      });
    });
  }

  uploadPackageImage(files: FileList) {
    if (!files || !files[0]) {
      return;
    }
    if (files[0].type === 'image/gif') {
      this.service.showError('Gif images are not allowed', 'Profile details');
      return;
    }
    this.fileToUpload = files.item(0);
    this.isLoadingResults = true;
    this.httpSub$ = this.service.uploadImage(this.globals.urls.signUp.noauth.uploadImage, this.fileToUpload).subscribe(
      res => {
        this.isLoadingResults = false;
        this.model.imageString = res.data.url;
      },
      err => {
        this.isLoadingResults = false;
        this.service.showError(err, 'ERROR');
      }
    );
  }

  clearPhoto() {
    this.model.imageString = null;
  }

  submit() {
    if (!this.model.imageString) {
      this.service.showError('Please upload profile image', 'Error');
      return;
    }
    if (this.pForm.invalid) {
      return;
    }
    const params = {
      firstName: this.pForm.value.firstName,
      lastName: this.pForm.value.lastName,
      displayName: this.pForm.value.displayName || this.pForm.value.firstName || '',
      profileImage: this.model.imageString,
      email: this.pForm.value.email,
      phoneNumberPrefix: '+1',
      phoneNumber: this.pForm.value.phoneno,
      rental: parseInt(this.pForm.value.rental, 10) !== 0,
      lineAddress: this.userAddress,
      city: this.city,
      country: this.country,
      postalCode: this.zipCode,
      state: this.state,
      mailingLineAddress: this.mailingAddress,
      mailingCity: this.mailingCity,
      mailingCountry: this.mailingCountry,
      mailingPostalCode: this.mailingZipCode,
      mailingState: this.mailingState,
      monthlyRentalAmount: this.pForm.value.monthlyRentalAmount,
      dob: moment(this.pForm.controls['dob'].value).valueOf() / 1000
    };
    localStorage.setItem('driverProfile', JSON.stringify(params));
    this.router.navigate(['/registration/drivers/assign-vehicle']);
  }
}
